// =============================
// Imports
// =============================

// External Dependencies
import axios from 'axios';
import _get from 'lodash/get';

// Constants
import * as acts from '../constants/ActionTypes';

// Helpers
import determineError, { MewoError } from '../../helpers/errors';
import { camelCaseKeysDeep, getApiUrl, getXPreferredLanguage } from '../../helpers/misc';

// =============================
// Actions
// =============================

export function getSuggestedAlbums() {
  return async (dispatch, getState) => {
    dispatch({
      type: acts.GET_SUGGESTED_ALBUMS_LOADING,
    });

    try {
      const response = await axios.get(getApiUrl('public/config/suggested/albums'), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'x-host': getState().core.serverContext.xHost,
          'x-auth': getState().user.token,
          'x-preferred-language': getXPreferredLanguage(),
          ...getState().core.serverContext.ssrRequestHeaders,
        },
      });

      dispatch({
        type: acts.SET_SUGGESTED_ALBUMS,
        payload: camelCaseKeysDeep(response.data),
      });

      dispatch({
        type: acts.GET_SUGGESTED_ALBUMS_SUCCESS,
      });
    } catch (err) {
      dispatch({
        type: acts.GET_SUGGESTED_ALBUMS_FAILURE,
        payload: {
          message: determineError(err),
          reqId: _get(err, 'response.data.reqId'),
        },
      });

      throw new MewoError({ error: err });
    }
  };
}

export function getSuggestedPlaylists() {
  return async (dispatch, getState) => {
    dispatch({
      type: acts.GET_SUGGESTED_PLAYLISTS_LOADING,
    });

    try {
      const response = await axios.get(getApiUrl('public/config/suggested/playlists'), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'x-host': getState().core.serverContext.xHost,
          'x-auth': getState().user.token,
          'x-preferred-language': getXPreferredLanguage(),
          ...getState().core.serverContext.ssrRequestHeaders,
        },
      });

      dispatch({
        type: acts.SET_SUGGESTED_PLAYLISTS,
        payload: camelCaseKeysDeep(response.data),
      });

      dispatch({
        type: acts.GET_SUGGESTED_PLAYLISTS_SUCCESS,
      });
    } catch (err) {
      dispatch({
        type: acts.GET_SUGGESTED_PLAYLISTS_FAILURE,
        payload: {
          message: determineError(err),
          reqId: _get(err, 'response.data.reqId'),
        },
      });

      throw new MewoError({ error: err });
    }
  };
}
